import { render, staticRenderFns } from "./doc1.vue?vue&type=template&id=1521c8db"
import script from "./doc1.vue?vue&type=script&lang=js"
export * from "./doc1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports